module.exports = __webpack_public_path__ + "static/media/check.aef8800d.svg";